'use strict';

function getReCaptchaToken(siteKey, action) {
    return new Promise(function (resolve) {
        try {
            grecaptcha.ready(function () {
                try {
                    grecaptcha.execute(siteKey, { action: action })
                        .then(function (token) {
                            resolve(token);
                        })
                        .catch(function () {
                            resolve(null);
                        });
                } catch (e) {
                    resolve(null);
                }
            });
        } catch (e) {
            resolve(null);
        }
    });
}

module.exports = {
    getReCaptchaToken: getReCaptchaToken
};